import { useAppSelector, useAppDispatch } from "../redux/hook";
import { MdOutlineErrorOutline, MdOutlineCheckCircleOutline, MdOutlineHighlightOff } from 'react-icons/md'
import { activateFullScreenPrompt } from "../redux/fullScreenPromptSlice";
import RoundButton from "./utility/RoundButton";
import Theme from "../Theme"

function FullScreenPrompt() {

    const promptType = useAppSelector(state => state.fullScreenPrompt.promptType)
    const dispatch = useAppDispatch()

    return (
        <div>
            {
                {
                    "loading":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-800/60 z-10">
                            <div className="flex flex-col items-center gap-4">
                                <div className="relative h-5 w-56 overflow-hidden">
                                        <span
                                            key="defaultFullScreenLoadingComponent"
                                            className="absolute inset-0 flex items-center justify-center text-white text-sm font-medium tracking-wide"
                                        >
                                            Loading...
                                        </span>
                                </div>
                                <div className="relative w-80 md:w-[28rem] h-1.5 rounded-full bg-white/20 overflow-hidden">
                                    <div className="absolute left-0 top-0 h-full w-1/3 rounded-full bg-white" style={{ animation: 'slide 1.4s ease-in-out infinite' }} />
                                </div>
                            </div>
                            <style>{`
                @keyframes slide {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(300%); }
                }
                `}</style>
                        </div>,
                    "error":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-700/60 z-10">
                            <MdOutlineErrorOutline className='h-24 w-24 text-ui-red mb-6' />
                            <h1 className="text-2xl font-medium text-white mb-6">Operation failed. Check log.</h1>
                            <RoundButton text={"Confirm"} colour={`${Theme.Colors.Primary}`} onClickAction={() => { dispatch(activateFullScreenPrompt("false")) }} extraStyle={"w-36"}></RoundButton>
                        </div>,
                    "finalised":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-700/60 z-10">
                            <MdOutlineCheckCircleOutline className='h-24 w-24 text-ui-lime mb-6' />
                            <h1 className="text-2xl font-medium text-white mb-6">Report Finalised!</h1>
                            <RoundButton text={"Confirm"} colour={`${Theme.Colors.Primary}`} onClickAction={() => { dispatch(activateFullScreenPrompt("false")) }} extraStyle={"w-36"}></RoundButton>
                        </div>,
                    "unfinalised":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-700/60 z-10">
                            <MdOutlineCheckCircleOutline className='h-24 w-24 text-ui-lime mb-6' />
                            <h1 className="text-2xl font-medium text-white mb-6">Report Unfinalised!</h1>
                            <RoundButton text={"Confirm"} colour={`${Theme.Colors.Primary}`} onClickAction={() => { dispatch(activateFullScreenPrompt("false")) }} extraStyle={"w-36"}></RoundButton>
                        </div>,
                    "published":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-700/60 z-10">
                            <MdOutlineCheckCircleOutline className='h-24 w-24 text-ui-lime mb-6' />
                            <h1 className="text-2xl font-medium text-white mb-6">Report Published!</h1>
                            <RoundButton text={"Confirm"} colour={`${Theme.Colors.Primary}`} onClickAction={() => { dispatch(activateFullScreenPrompt("false")) }} extraStyle={"w-36"}></RoundButton>
                        </div>,
                    "accepted":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-700/60 z-10">
                            <MdOutlineCheckCircleOutline className='h-24 w-24 text-ui-lime mb-6' />
                            <h1 className="text-2xl font-medium text-white mb-6">New Baseline Accepted!</h1>
                            <RoundButton text={"Confirm"} colour={`${Theme.Colors.Primary}`} onClickAction={() => { dispatch(activateFullScreenPrompt("false")) }} extraStyle={"w-36"}></RoundButton>
                        </div>,
                    "rejected":
                        <div className="fixed flex flex-col items-center justify-center top-0 left-0 h-screen w-screen backdrop-blur-sm bg-slate-700/60 z-10">
                            <MdOutlineHighlightOff className='h-24 w-24 text-ui-red mb-6' />
                            <h1 className="text-2xl font-medium text-white mb-6">New Baseline Rejected!</h1>
                            <RoundButton text={"Confirm"} colour={`${Theme.Colors.Primary}`} onClickAction={() => { dispatch(activateFullScreenPrompt("false")) }} extraStyle={"w-36"}></RoundButton>
                        </div>
                }[promptType]
            }

        </div>

    )
}

export default FullScreenPrompt